import React, { useCallback } from 'react';
import { SkillLevel } from '../common/types';
import { useAddEmployeeSkill } from '../common/useEmployeeSkillsMutations';
import { useUserInfo } from '../../../context/UserInfo';
import {
  AddEmployeeSkillDialog,
  Props as AddEmployeeSkillDialogProps,
} from './AddEmployeeSkillDialog';

type Props = Omit<
  AddEmployeeSkillDialogProps,
  'onSkillAdded' | 'inProgress' | 'isSelfView'
> & {
  employeeId: string;
};

export const AddEmployeeSkillDialogConnected: React.FC<
  React.PropsWithChildren<Props>
> = (props) => {
  if (!props.show) {
    return null;
  }
  return <Content {...props} />;
};

const Content: React.FC<React.PropsWithChildren<Props>> = ({
  employeeId,
  ...props
}) => {
  const { onClose } = props;
  const { id: meId } = useUserInfo();

  const { addEmployeeSkill, inProgress: addEmployeeSkillInProgress } =
    useAddEmployeeSkill();

  const handleSkillAdded = useCallback(
    (
      skillId: string,
      rate: SkillLevel | undefined,
      monthsExperience: number | null,
    ) => {
      addEmployeeSkill({
        skillId,
        employeeId,
        rate: rate ?? null,
        monthsExperience,
      }).then(() => {
        onClose();
      });
    },
    [addEmployeeSkill, employeeId, onClose],
  );

  return (
    <AddEmployeeSkillDialog
      {...props}
      isSelfView={meId === employeeId}
      inProgress={addEmployeeSkillInProgress}
      onSkillAdded={handleSkillAdded}
    />
  );
};
